
import { defineComponent } from 'vue'
import { RightOutlined, DownOutlined } from '@ant-design/icons-vue'
export default defineComponent({
  name: 'Sunmenu',
  components: {
    RightOutlined,
    DownOutlined
  },
  props: {
    mode: {
      type: String,
      default: () => {
        return ''
      }
    },
    theme: {
      type: String,
      default: () => {
        return ''
      }
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    thisInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  setup(props, context) {
    return {}
  }
})
